import {ActivityDirectionDisplay} from "./ActivityDirectionDisplay";
import {Activity} from "../../types/Activity";

interface ActivityHeaderDisplayProps {
    activity: Activity;
    displayIndex: number;
    purchaseOrderNumber?: string | null;
}

export let ActivityHeaderDisplay = function (props: ActivityHeaderDisplayProps) {
    let purchaseOrderNumberDisplay = undefined;
    if (props.purchaseOrderNumber) {
        purchaseOrderNumberDisplay = (
            <div className="activity-header-purchase-order-number">
                {props.purchaseOrderNumber}
            </div>
        )
    }
    return (
        <div className="activity-header">
            <div className="activity-header-content">
                <div className="activity-header-content-left">
                    <div className="activity-header-content-left-inner">
                        <div className="activity-header-label">{`ACTIVITY ${props.displayIndex}`}</div>
                        {purchaseOrderNumberDisplay}
                    </div>
                </div>
                <div className="activity-header-content-right">
                    <div className="activity-header-content-right-content">
                        <div className="activity-header-direction">
                            <ActivityDirectionDisplay
                                directionName={props.activity.activity_direction.name}
                                abbreviated={false}
                            />
                        </div>
                        <div className="activity-header-right-divider"/>
                        <div className="activity-header-scope">
                            {props.activity.activity_scope.name}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
